import React from 'react';

import mapSvg from '../../../static/images/map.svg';
import mapDark from '../../../static/images/map-dark.png';
import backgroundGradient from '../../../static/images/background-gradient.svg';
import novanaut from '../../../static/images/novanaut.svg';

import CountryOverlay from './CountryOverlay';
import PopOut from './PopOut';


const UpperBackground = () => (
    <div className="upper-background">
        <img className="background background--small" src={mapDark} alt="" />
        <img className="background background--big" src={mapSvg} alt="" />
        <img className="background background--gradient" src={backgroundGradient} alt="" />

        <CountryOverlay countryName="Estonia" overlayName="small" redirectUrl="https://www.novastar.ee/">
            <PopOut text="Coming soon" direction="left" />
        </CountryOverlay>
        <CountryOverlay countryName="Latvia" overlayName="crane" redirectUrl="https://www.novastar.lv/">
            <PopOut text="Coming soon" direction="left" />
        </CountryOverlay>
        <CountryOverlay countryName="Lithuania" overlayName="rocket" redirectUrl="https://www.novastar.lt/">
            <PopOut text="Ready for countdown" direction="left" />
        </CountryOverlay>
        <CountryOverlay countryName="Finland" overlayName="flag" redirectUrl="https://www.novastar.fi/">
            <PopOut text="Coming soon" direction="right" />
        </CountryOverlay>
        <CountryOverlay countryName="Sweden" overlayName="flag">
            <PopOut text="Coming soon" direction="right" />
        </CountryOverlay>

        <div className="background novanaut">
            <img src={novanaut} alt="Novanaut" />
            <PopOut text="Preparing our next missions" direction="right" dynamic={false} />
        </div>
    </div>
);

export default UpperBackground;



// WEBPACK FOOTER //
// ./src/components/UpperBackground.js